import { PageCanvas } from "@/components/page-canvas";
import { Form, Head, Link, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import SettingsLayout from "@/layouts/settings_layout";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { userCustomerDeletionPath, userCustomerDeletionsPath } from "@/routes";

export interface Deletion {
  id: string;
  customer_name: string | null;
  state: "pending" | "restored" | "purged";
  purge_after: string;
  restorable: boolean;
  retain_until: string | null;
  retention_basis: string | null;
  archive_path: string | null;
}

export default function ShowDeletion({ deletion }: { deletion: Deletion }) {
  const { t, i18n } = useTranslation();
  const { i18n: context } = usePage().props;
  return (
    <SettingsLayout>
      <Head title={t("customer_deletions.title")} />
      <PageCanvas padded={false}>
        <h1 className="text-page font-display">
          {t("customer_deletions.states." + deletion.state)}
        </h1>
        <Card>
          <CardContent className="space-y-4 pt-6">
            {deletion.customer_name && (
              <p className="font-medium break-words">
                {deletion.customer_name}
              </p>
            )}
            <p>{t("customer_deletions.explanation")}</p>
            <p>
              {t("customer_deletions.due")}:{" "}
              <time dateTime={deletion.purge_after}>
                {new Intl.DateTimeFormat(i18n.language, {
                  dateStyle: "medium",
                  timeStyle: "short",
                  timeZone: context.time_zone,
                }).format(new Date(deletion.purge_after))}
              </time>
            </p>
            {deletion.retain_until && (
              <p className="text-sm">
                {t("customer_deletions.deadline")}: {deletion.retain_until}
                <br />
                {deletion.retention_basis}
              </p>
            )}
            {deletion.archive_path && (
              <a
                className="inline-block underline"
                href={deletion.archive_path}
              >
                {t("customer_deletions.archive")}
              </a>
            )}
            {deletion.restorable && (
              <Form
                action={userCustomerDeletionPath(deletion.id)}
                method="delete"
              >
                {({ processing }) => (
                  <Button type="submit" disabled={processing}>
                    {t("customer_deletions.restore")}
                  </Button>
                )}
              </Form>
            )}
            <Link
              className="inline-block underline"
              href={userCustomerDeletionsPath()}
            >
              {t("customer_deletions.queue")}
            </Link>
          </CardContent>
        </Card>
      </PageCanvas>
    </SettingsLayout>
  );
}
